/*
 * free-gift.js — "spend £35, get a free Gran Festa 250g" promo.
 *
 * Does two jobs:
 *  1. ENGINE: auto-adds the gift (line property _free_gift:'true') when the
 *     non-gift subtotal >= threshold, removes it below, and respects a manual
 *     removal for the rest of the session. The Shopify "Buy X Get Y" automatic
 *     discount is what makes the line £0 — this file never touches prices.
 *  2. SLIDER: renders a progress bar inside the SlideCart HQ popout cart
 *     (#slidecarthq). The app re-renders its drawer on every cart change, so a
 *     MutationObserver re-inserts/updates the bar whenever it gets wiped.
 *
 * Cart changes made INSIDE the app drawer never fire the theme's pubsub, so we
 * also intercept fetch/XHR calls to /cart/(add|change|update|clear) and
 * re-evaluate after each one. Our own requests are tagged (__freeGift) and
 * ignored by the interceptor. All failures are swallowed — never blocks checkout.
 */
(function () {
  var CFG = window.GimokaFreeGift;
  if (!CFG || !CFG.giftVariantId) return; // no config or unresolved gift → do nothing

  var END_MS = new Date(CFG.endIso).getTime();
  var DECLINED_KEY = 'gimoka_gift_declined';
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)/;
  var busy = false;
  var evalTimer = null;
  var prevGiftPresent = null;
  var lastCart = null;

  function isActive() {
    return CFG.enabled === true && CFG.thresholdPennies > 0 && Date.now() < END_MS;
  }
  function declined() {
    try { return sessionStorage.getItem(DECLINED_KEY) === '1'; } catch (e) { return false; }
  }
  function setDeclined(v) {
    try { v ? sessionStorage.setItem(DECLINED_KEY, '1') : sessionStorage.removeItem(DECLINED_KEY); } catch (e) {}
  }
  function isGiftLine(item) {
    return item.properties && (item.properties._free_gift === 'true' || item.properties._free_gift === true);
  }
  function nonGiftSubtotal(cart) {
    return cart.items.reduce(function (sum, i) { return isGiftLine(i) ? sum : sum + i.final_line_price; }, 0);
  }
  function findGift(cart) {
    for (var i = 0; i < cart.items.length; i++) { if (isGiftLine(cart.items[i])) return cart.items[i]; }
    return null;
  }
  function money(pennies) {
    return '£' + (pennies / 100).toFixed(2);
  }

  /* ---------------- SlideCart drawer progress bar ---------------- */

  var STYLE_ID = 'GimokaGiftBarStyle';
  var BAR_ID = 'GimokaGiftBar';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '#' + BAR_ID + '{padding:12px 16px;background:#fff4f5;border-bottom:1px solid rgba(243,0,43,.2);font-size:13px;line-height:1.35;}' +
      '#' + BAR_ID + ' .ggb-text{margin:0 0 8px;color:#1a1a1a;font-weight:600;}' +
      '#' + BAR_ID + ' .ggb-text strong{color:#f3002b;}' +
      '#' + BAR_ID + ' .ggb-track{height:6px;border-radius:999px;background:rgba(243,0,43,.15);overflow:hidden;}' +
      '#' + BAR_ID + ' .ggb-fill{height:100%;border-radius:999px;background:#f3002b;transition:width .3s ease;}';
    document.head.appendChild(s);
  }

  // The app panel is <div class="slidecarthq right light"> inside #slidecarthq
  // (sibling of .slidecarthq-overlay). Class names are the app's — may change
  // if the app updates; every lookup below degrades to "no bar" rather than
  // breaking the cart.
  function findPanel() {
    var nodes = document.querySelectorAll('.slidecarthq');
    for (var i = 0; i < nodes.length; i++) {
      if (!/slidecarthq-overlay/.test(nodes[i].className)) return nodes[i];
    }
    return null;
  }

  function renderBar() {
    var bar = document.getElementById(BAR_ID);
    if (!isActive() || !lastCart || lastCart.item_count === 0) {
      if (bar) bar.remove();
      return;
    }
    var panel = findPanel();
    if (!panel) return; // drawer not on page / not yet built

    var subtotal = nonGiftSubtotal(lastCart);
    var remaining = Math.max(0, CFG.thresholdPennies - subtotal);
    var pct = Math.min(100, Math.round((subtotal * 100) / CFG.thresholdPennies));
    var state = pct + '|' + remaining;

    if (bar && panel.contains(bar) && bar.getAttribute('data-state') === state) return; // no change → no DOM churn

    ensureStyle();
    if (!bar || !panel.contains(bar)) {
      if (bar) bar.remove();
      bar = document.createElement('div');
      bar.id = BAR_ID;
      // Prefer to sit directly under the app's own rewards/progress section so
      // the two bars read as one stack; fall back to just under the header.
      var anchor = null;
      for (var i = 0; i < panel.children.length; i++) {
        var c = panel.children[i];
        if (c.querySelector && c.querySelector('[class*="rewards"]')) { anchor = c; break; }
      }
      if (anchor) anchor.insertAdjacentElement('afterend', bar);
      else if (panel.children.length > 1) panel.insertBefore(bar, panel.children[1]);
      else panel.appendChild(bar);
    }
    bar.setAttribute('data-state', state);
    bar.innerHTML =
      remaining === 0
        ? '<p class="ggb-text">Your <strong>FREE Gran Festa 250g Ground Coffee</strong> has been added!</p>' +
          '<div class="ggb-track"><div class="ggb-fill" style="width:100%"></div></div>'
        : '<p class="ggb-text">Spend <strong>' + money(remaining) + '</strong> more for a <strong>FREE Gran Festa 250g Ground Coffee</strong></p>' +
          '<div class="ggb-track"><div class="ggb-fill" style="width:' + pct + '%"></div></div>';
  }

  var rafPending = false;
  function scheduleRender() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () { rafPending = false; renderBar(); });
  }

  function observeDrawer() {
    var host = document.getElementById('slidecarthq') || document.body;
    new MutationObserver(scheduleRender).observe(host, { childList: true, subtree: true });
  }

  /* ---------------- theme section refresh (cart page + header bubble) ---------------- */

  function sectionsToRender() {
    var list = [];
    var mci = document.getElementById('main-cart-items');
    if (mci) list.push({ id: 'main-cart-items', section: mci.dataset.id, selector: '.js-contents' });
    var mcf = document.getElementById('main-cart-footer');
    if (mcf) list.push({ id: 'main-cart-footer', section: mcf.dataset.id, selector: '.js-contents' });
    if (document.getElementById('cart-icon-bubble')) list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return list;
  }
  function applySections(sections) {
    if (!sections) return;
    sectionsToRender().forEach(function (s) {
      var container = document.getElementById(s.id);
      if (!container || !sections[s.section]) return;
      var doc = new DOMParser().parseFromString(sections[s.section], 'text/html');
      var el = doc.querySelector(s.selector);
      var target = container.querySelector(s.selector) || container;
      if (el) target.innerHTML = el.innerHTML;
    });
  }

  /* ---------------- cart mutations ---------------- */

  function postJSON(url, body) {
    var list = sectionsToRender();
    if (list.length) {
      body.sections = list.map(function (s) { return s.section; }).join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      __freeGift: true // interceptor ignores our own requests
    }).then(function (r) { return r.json(); });
  }

  // Tell SlideCart HQ to re-fetch the cart and re-render its drawer after we
  // mutate the cart (the app doesn't see our programmatic add/remove otherwise).
  function refreshSlideCart() {
    try { if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE(); } catch (e) {}
  }

  function addGift() {
    busy = true;
    return postJSON('/cart/add.js', { items: [{ id: CFG.giftVariantId, quantity: 1, properties: { _free_gift: 'true' } }] })
      .then(function (res) { prevGiftPresent = true; applySections(res && res.sections); refreshSlideCart(); })
      .catch(function (e) { console.warn('[free-gift] add failed', e); })
      .finally(function () { busy = false; scheduleEvaluate(150); });
  }
  function removeGift(key) {
    busy = true;
    return postJSON('/cart/change.js', { id: key, quantity: 0 })
      .then(function (res) { prevGiftPresent = false; applySections(res && res.sections); refreshSlideCart(); })
      .catch(function (e) { console.warn('[free-gift] remove failed', e); })
      .finally(function () { busy = false; scheduleEvaluate(150); });
  }

  /* ---------------- engine ---------------- */

  function evaluate() {
    if (busy) { scheduleEvaluate(250); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' }, __freeGift: true })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return; // bot-check / non-cart response → try again on next trigger
        lastCart = cart;
        var gift = findGift(cart);
        var present = !!gift;

        if (!isActive()) {                       // offer off/expired → clean up any auto-gift
          if (present) { removeGift(gift.key); return; }
          prevGiftPresent = false;
        } else if (nonGiftSubtotal(cart) < CFG.thresholdPennies) {
          setDeclined(false);                    // reset: crossing again may re-add
          if (present) { removeGift(gift.key); return; }
          prevGiftPresent = false;
        } else if (present) {
          prevGiftPresent = true;
        } else if (prevGiftPresent === true) {   // was there, now gone, still >= threshold → user removed it
          setDeclined(true);
          prevGiftPresent = false;
        } else if (!declined()) {
          addGift();
          return;                                 // renderBar runs after the add settles
        } else {
          prevGiftPresent = false;
        }
        scheduleRender();
      })
      .catch(function (e) { console.warn('[free-gift] evaluate failed', e); });
  }

  function scheduleEvaluate(delay) {
    clearTimeout(evalTimer);
    evalTimer = setTimeout(evaluate, delay || 100);
  }

  /* ---------------- triggers ---------------- */

  // Intercept fetch — catches the theme, SlideCart, and any other app mutating the cart.
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (!(init && init.__freeGift) && CART_MUTATION_RE.test(url)) {
      p.then(function () { scheduleEvaluate(120); }, function () {});
    }
    return p;
  };
  // Intercept XHR for apps that don't use fetch.
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cartMutation = CART_MUTATION_RE.test(url || '');
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__cartMutation) this.addEventListener('loadend', function () { scheduleEvaluate(120); });
    return _send.apply(this, arguments);
  };
  // Theme pubsub (belt & braces — theme adds also go through fetch above).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { scheduleEvaluate(120); });
  }

  observeDrawer();
  evaluate(); // initial run (defer script → DOM already parsed)
})();